<template>
    <div class="c-transfer">
        <transfer-panel style="width:100px;flex:1" v-bind="$props" ref="leftPanel" :data="sourceData"
            :arrowConfig="arrowConfigRight" :loading="leftLoading" :emptyText="emptyText.left" :customProps="leftProps"
            @checked-change="onSourceCheckedChange" @arrowButtonClick="onLeftItemArrowClick">
            <template v-slot:header v-if="$slots['left-header']">
                <slot name="left-header"></slot>
            </template>
            <template v-slot:footer v-if="$slots['left-footer']">
                <slot name="left-footer"></slot>
            </template>

        </transfer-panel>
        <div class="c-transfer__buttons">
            <div class="c-transfer__buttons--content">
                <template v-if="showButtons">
                    <span style="margin-bottom: 20px;">
                        <el-button type="primary" size="mini" :loading="addToRightLoading" @click.native="addToRight"
                            :disabled="leftChecked.length === 0">
                            <i class="el-icon-arrow-right" v-if="!addToRightLoading"></i>

                        </el-button>
                    </span>
                    <span>
                        <el-button type="primary" size="mini" :loading="addToLeftLoading" @click.native="addToLeft"
                            :disabled="rightChecked.length === 0">
                            <i class="el-icon-arrow-left" v-if="!addToLeftLoading"></i>
                        </el-button>
                    </span>
                </template>
                <span v-else style="transform: rotate(90deg);">
                    <i class="el-icon-sort" style="font-size: 20px;"></i>
                </span>

            </div>
        </div>
        <transfer-panel style="width:100px;flex:1" v-bind="$props" ref="rightPanel" :data="targetData"
            :arrowConfig="arrowConfigLeft" :loading="rightLoading" @checked-change="onTargetCheckedChange"
            @arrowButtonClick="onRightItemArrowClick" :emptyText="emptyText.right" :customProps="rightProps">
            <template v-slot:header v-if="$slots['right-header']">
                <slot name="right-header"></slot>
            </template>
            <template v-slot:footer v-if="$slots['right-footer']">
                <slot name="right-footer"></slot>
            </template>

        </transfer-panel>
    </div>
</template>

<script>
import TransferPanel from './transfer-panel.vue';

export default {
    name: 'CTransfer',
    components: {
        TransferPanel,
    },
    props: {
        value: {
            type: Array,
            default() {
                return [];
            },
        },
        data: {
            type: Array,
            default() {
                return [];
            },
        },
        /**
     * 是否支持多选，默认为 true,值为true 时显示checkbox
     */
        multiple: {
            type: Boolean,
            default: true,
        },
        renderContent: Function,
        // 左侧列表是否处于加载中状态
        leftLoading: {
            type: Boolean,
            default: false,
        },
        // 右侧列表是否处于加载中状态
        rightLoading: {
            type: Boolean,
            default: false,
        },
        leftDefaultChecked: {
            type: Array,
            default() {
                return [];
            },
        },
        rightDefaultChecked: {
            type: Array,
            default() {
                return [];
            },
        },
        props: {
            type: Object,
            default() {
                return {
                    label: 'label',
                    key: 'key',
                    disabled: 'disabled',
                };
            },
        },
        /**
     * 右侧列表元素的排序策略：若为 original，
     * 则保持与数据源相同的顺序；若为 push，
     * 则新加入的元素排在最后；若为 unshift，则新加入的元素排在最前
     */
        targetOrder: {
            type: String,
            default: 'original',
            validator(val) {
                return ['original', 'push', 'unshift'].indexOf(val) !== -1;
            },
        },
        format: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
    * 是否显示全选复选框
    */
        showCheckAll: {
            type: Boolean,
            default: true,
        },
        footerHeight: {
            type: Number,
            default: 40,
        },
        /**
    * 是否显示中间操作按钮
    */
        showButtons: {
            type: Boolean,
            default: true,
        },
        /**
    * 自定义添加到右侧的校验函数，若返回 false，则不添加到右侧列表
    */
        beforeAddToRight: Function,
        /**
    * 自定义添加到左侧侧的校验函数，若返回 false，则不添加到左侧列表
    */
        beforeAddToLeft: Function,
        emptyText: {
            type: Object,
            default() {
                return {
                    left: '暂无数据',
                    right: '请从左边选择数据',
                };
            },
        },
        /**
         * 传给左侧列表item的自定义属性
         * */
        leftProps: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
         * 传给右侧列表item的自定义属性
         * */
        rightProps: {
            type: Object,
            default() {
                return {};
            },
        },
        /**
         * 是否支持过滤
         */
        filterable: Boolean,
        filterMethod: Function,
        filterPlaceholder: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            leftChecked: [],
            rightChecked: [],
            addToRightLoading: false,
            addToLeftLoading: false,
            // 穿梭框数据对象，位置，名称，图标位置，图标等配置信息
            arrowConfigRight: {
                position: 'right',
                name: '到右边',
                iconPosition: 'right',
                icon: 'el-icon-arrow-right',
            },
            arrowConfigLeft: {
                position: 'right',
                name: '到左边',
                iconPosition: 'left',
                icon: 'el-icon-arrow-left',
            },
        };
    },
    computed: {
        sourceData() {
            return this.data.filter((item) => this.value.indexOf(item[this.props.key]) === -1);
        },
        targetData() {
            if (this.targetOrder === 'original') {
                return this.data.filter((item) => this.value.indexOf(item[this.props.key]) > -1);
            } else {
                return this.value.reduce((arr, cur) => {
                    const val = this.dataObj[cur];
                    if (val) {
                        arr.push(val);
                    }
                    return arr;
                }, []);
            }
        },
    },
    methods: {
        onSourceCheckedChange(val, movedKeys) {
            this.leftChecked = val;
            if (movedKeys === undefined) return;
            this.$emit('left-check-change', val, movedKeys);
        },

        onTargetCheckedChange(val, movedKeys) {
            // console.log('onTargetCheckedChange', val)
            this.rightChecked = val;
            if (movedKeys === undefined) return;
            this.$emit('right-check-change', val, movedKeys);
        },
        async addToLeft() {
            let rightCheckedData = [];
            let rightChecked = this.rightChecked.slice();
            this.targetData.forEach((item) => {
                if (rightChecked.includes(item[this.props.key])) {
                    rightCheckedData.push(item);
                }
            });
            let currentValue = this.value.slice();
            if (typeof this.beforeAddToLeft === 'function') {
                this.addToLeftLoading = true;
                setTimeout(() => {
                    this.addToLeftLoading = false;
                }, 1000 * 5);

                // 如果有自定义校验函数，则执行
                const valid = await this.beforeAddToLeft(rightChecked, rightCheckedData);

                this.addToLeftLoading = false;
                if (!valid) return;
            }

            rightChecked.forEach((item) => {
                const index = currentValue.indexOf(item);

                if (index > -1) {
                    currentValue.splice(index, 1);
                }
            });

            this.$emit('input', currentValue);
            this.$emit('change', currentValue, 'left', this.rightChecked);
        },

        /**
    * 将选中的左侧项目添加到右侧
    */
        async addToRight() {
            let currentValue = this.value.slice();
            const itemsToBeMoved = [];
            const itemsToBeMovedData = [];
            const key = this.props.key;
            this.data.forEach((item) => {
                const itemKey = item[key];
                if (
                    this.leftChecked.indexOf(itemKey) > -1
                    && this.value.indexOf(itemKey) === -1
                ) {
                    itemsToBeMoved.push(itemKey);
                    itemsToBeMovedData.push(item);
                }
            });
            if (typeof this.beforeAddToRight === 'function') {
                this.addToRightLoading = true;
                setTimeout(() => {
                    this.addToRightLoading = false;
                }, 1000 * 5);
                // 如果有自定义校验函数，则执行
                const valid = await this.beforeAddToRight(itemsToBeMoved, itemsToBeMovedData);
                this.addToRightLoading = false;
                if (!valid) return;
            }

            currentValue = this.targetOrder === 'unshift'
                ? itemsToBeMoved.concat(currentValue)
                : currentValue.concat(itemsToBeMoved);
            this.$emit('input', currentValue);
            this.$emit('change', currentValue, 'right', this.leftChecked);
        },
        onLeftItemArrowClick(keyValue, data) {
            this.addToRight();
        },
        onRightItemArrowClick(keyValue, data) {
            this.addToLeft();
        },
    },
    mounted() {
        // console.log(this.$slots);
    },
};
</script>

<style lang="scss" scoped>
.c-transfer {
    display: flex;
    align-items: center;
    box-sizing: border-box;

    &__buttons {
        position: relative;
        margin: 0 8px;
        height: 100%;

        &--content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
    }

}
</style>
